<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/145/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为深入贯彻党的二十大精神，认真落实中央和省委市委、县委人才工作会议精神，推动乡村全面振兴，促进农业农村高质量发展，培育一批与产业需求相适应、与农村发展相协调、具有较强示范带动作用的高素质乡村振兴人才队伍，依据《中共蒲江县委办公室蒲江县人民政府办公室关于印发〈蒲江县加快建设具有比较优势的人才聚集地若干政策措施〉的通知》（蒲委室〔2023〕4号）第五条要求，结合我县实际，制定本实施细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/145/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            在城乡规划、基层治理、农业科技研发、农业新产品新技术开发推广农商文旅融合发展等方面业绩突出，为乡村振兴和农业农村现代化方面做出突出贡献的个人（团队）。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/145/title2.png" alt="" />
          <div class="content" style="background-color: #fff">
            乡村振兴优秀人才（团队）评选每2年开展一次评选，分三个等级：蒲江县乡村振兴五星级优秀人才（团队）、蒲江县乡村振兴四星级优秀人才（团队）、蒲江县乡村振兴三星级优秀人才（团队）。各等级名额根据评选当年实际情况确定。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/145/title3.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.5rem">
              <div class="title">一、资金奖励</div>
              <div>
                “蒲江县乡村振兴五星级优秀人才（团队）”可获得20万元贡献奖励；“蒲江县乡村振兴四星级优秀人才（团队）”可获得15万元贡献奖励；“蒲江县乡村振兴三星级优秀人才（团队）”可获得10万元贡献奖励。
              </div>
            </div>
            <div class="des">
              <div class="title">二、其他</div>
              <div>
                《蒲江县加快建设具有比较优势的人才聚集地若干政策措施》中关于人才安居、子女入学（入园）、就医等配套政策。
              </div>
            </div>
          </div>
        </div>

        <div class="part-four">
          <img src="../assets/imgs/145/title4.png" class="part-two-title-img" />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                由企业、行业协会、专合组织、家庭农场、个人自荐等方式自主申报，填写《蒲江县乡村振兴优秀人才（团队）申报表》并附相关佐证材料，报属地镇（街道）。佐证材料包括但不限于个人（团队）和服务项目的荣誉证书、技能证书；县级以上新闻媒体的宣传报道和优秀案例及个人（团队）对乡村振兴有突出成效和明显示范带动的相关证明材料。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">初审</div>
              </div>
              <div class="part-four-content1">
                镇（街道）对自主申报的乡村振兴优秀人才（团队）违规违纪、违法犯罪、诚实守信等方面进行资格审查和初审，初审后在单位公示栏公示3个工作日，自公示次日开始计算。公示无异议后按乡村振兴优秀人才（团队）申报类别分别报送县委社会工作部、县规自局、县农业农村局、县文体旅局。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">复审</div>
              <div class="part-four-content1">
                县级相关部门对镇（街道）报送的乡村振兴优秀人才（团队）进行复审，复审后在单位公示栏公示3个工作日，自公示次日开始计算。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg4">评审</div>
              <div class="part-four-content1">
                县农业农村局会同县委社工部、县规自局、县文体旅局对复审通过的乡村振兴优秀人才（团队）进行评审，分别选出乡村振兴五星级、四星级和三星级优秀人才（团队）推荐人选。评审前对推荐人选违规违纪、违法犯罪、诚实守信等方面进行审查。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg5">审定</div>
              <div class="part-four-content1">
                县农业农村局对经评审推荐的乡村振兴优秀人才（团队）在蒲江县公众信息网公示3个工作日，公示无异议后由县农业农村局党组会研究确定。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg6">公示</div>
              <div class="part-four-content1">
                对审定的乡村振兴优秀人才（团队），通过公众信息网等形式在全县范围内进行公示，公示期为5个工作日。
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/145/title5.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88522521">028-88522521</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              蒲江县农业农村局
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="info" src="../assets/imgs/145/code.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.43rem;
    height: 5.84rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
